export const SET_BUSINESS_CONTACT_REQUEST = "SET_BUSINESS_CONTACT_REQUEST";
export const SET_BUSINESS_CONTACT_SUCCESS = "SET_BUSINESS_CONTACT_SUCCESS";
export const SET_BUSINESS_CONTACT_FAILURE = "SET_BUSINESS_CONTACT_FAILURE";